/*
  Y2K kart zemini (2026-11-02) — kart fotoğraf alanı 4:5 + contain (y2k-siyah.css).
  Kare ayakkabı fotoğrafının üstünde/altında kalan boşluk, fotoğrafın KENDİ kenar
  rengiyle boyanır → zemin sınırı görünmez. (Ayakkabı fotoğraflarının zemini tek tip
  değil: çoğu ~#F3–#F4, bir kısmı saf beyaz — tek sabit renk ikisini karşılamıyor.)
  - Asıl görsele dokunulmaz: aynı görselin 48px'lik küçük kopyası ayrıca indirilir
    (~1 KB), üst/alt (ya da sol/sağ) iki kenar satırının medyan rengi okunur.
  - Üst ve alt boşluk ayrı renk alır: iki duraklı keskin gradyan.
  - Fotoğraf kutuyu zaten dolduruyorsa (giyim ≈4:5) hiçbir şey yapılmaz.
  - Hata / zaman aşımı / okunamayan görselde hiçbir şey yazılmaz → CSS zemini
    #F1F1F1 kalır. Görsele filtre/tint YOK (CLAUDE.md §1).
  - Event delegation (load, capture fazı): lazy yüklenen ve sonradan eklenen kartlar
    (facet yenilemesi, öneriler) ekstra tarama gerektirmez.
*/
(function () {
  'use strict';

  if (window.__y2kKartZemin) return;
  window.__y2kKartZemin = true;

  var SEL = '.y2k-card--prod .y2k-shoe-img--main:not(.y2k-shoe-img--ph)';
  var KUTU_ORAN = 4 / 5;
  var KUCUK = 48;

  function kucukUrl(src) {
    try {
      var u = new URL(src, location.href);
      u.searchParams.set('width', KUCUK);
      u.searchParams.delete('height');
      u.searchParams.delete('crop');
      return u.href;
    } catch (e) {
      return null;
    }
  }

  function medyan(a) {
    a.sort(function (x, y) { return x - y; });
    return a[a.length >> 1];
  }

  function renk(d, pikseller) {
    var r = [], g = [], b = [];
    for (var i = 0; i < pikseller.length; i++) {
      var p = pikseller[i] * 4;
      r.push(d[p]); g.push(d[p + 1]); b.push(d[p + 2]);
    }
    return 'rgb(' + medyan(r) + ',' + medyan(g) + ',' + medyan(b) + ')';
  }

  function isle(img) {
    if (img.dataset.y2kZemin) return;
    var w = img.naturalWidth, h = img.naturalHeight;
    if (!w || !h) return;
    img.dataset.y2kZemin = '1';

    var oran = w / h;
    if (Math.abs(oran - KUTU_ORAN) < 0.03) return;
    var kutu = img.closest('.y2k-shoe-box');
    var url = kucukUrl(img.currentSrc || img.src);
    if (!kutu || !url) return;

    var k = new Image();
    k.crossOrigin = 'anonymous';
    k.decoding = 'async';
    k.onload = function () {
      try {
        var cw = k.naturalWidth, ch = k.naturalHeight;
        var c = document.createElement('canvas');
        c.width = cw;
        c.height = ch;
        var x = c.getContext('2d', { willReadFrequently: true });
        x.drawImage(k, 0, 0);
        var d = x.getImageData(0, 0, cw, ch).data;
        var yatay = oran > KUTU_ORAN;   // geniş görsel: boşluk üstte/altta
        var bas = [], son = [], i;
        if (yatay) {
          for (i = 0; i < cw; i++) {
            bas.push(i, cw + i);
            son.push((ch - 1) * cw + i, (ch - 2) * cw + i);
          }
        } else {
          for (i = 0; i < ch; i++) {
            bas.push(i * cw, i * cw + 1);
            son.push(i * cw + cw - 1, i * cw + cw - 2);
          }
        }
        kutu.style.background = 'linear-gradient(' + (yatay ? 'to bottom' : 'to right') + ', ' +
          renk(d, bas) + ' 50%, ' + renk(d, son) + ' 50%)';
      } catch (e) { /* okunamadı → #F1F1F1 kalır */ }
    };
    k.src = url;
  }

  document.addEventListener('load', function (e) {
    var t = e.target;
    if (t && t.tagName === 'IMG' && t.matches(SEL)) isle(t);
  }, true);

  function tara() {
    var imgs = document.querySelectorAll(SEL);
    for (var i = 0; i < imgs.length; i++) {
      if (imgs[i].complete) isle(imgs[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', tara);
  } else {
    tara();
  }
})();
